import { type Router, type RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useUserStore } from '@/stores/userStore'
import { useRedirectStore } from '@/stores/redirectStore'

export function setupRouterGuard(router: Router): void {
  router.beforeEach(async (to: RouteLocationNormalized) => {
    const auth = useAuthStore()
    const userStore = useUserStore()
    const redirectStore = useRedirectStore()

    const isLoggedIn = auth.isLoggedIn
    const firma = userStore.firma
    const userRole = userStore.roles?.[0] || ''

    // 1. If going to login page, redirect to home if already logged in
    if (to.name === 'login') {
      return isLoggedIn && firma ? '/' : true
    }

    // 2. If user is logged in but firma is not set, redirect to login to select the account
    if (isLoggedIn && !firma) {
      return 'login'
    }

    // 3. Always allow public routes
    if (to.meta.public) return true

    // 4. For protected routes, check authentication (this may refresh token)
    if (!isLoggedIn) {
      console.error('User is not logged in Pinia. Will call logout.')
      auth.piniaLogout()
      if (to.params.id) {
        redirectStore.setRedirect(to)
      }
      throw new Error('Session expired. Please log in again.')
    }

    // 5. Role-based guard
    if (to.meta.requiredRoles) {
      const requiredRoles = Array.isArray(to.meta.requiredRoles)
        ? to.meta.requiredRoles
        : [to.meta.requiredRoles]

      if (!requiredRoles.includes(userRole)) {
        console.warn(`Access denied. User role "${userRole}" not in ${requiredRoles}`)
        return { name: 'unauthorized' }
      }
    }

    // 6. Allow access
    return true
  })
}
